'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FileSize = require('./FileSize');

var _FileSize2 = _interopRequireDefault(_FileSize);

var _Label = require('./Label');

var _Label2 = _interopRequireDefault(_Label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FileDetails(_ref) {
  var contentSha1 = _ref.contentSha1,
      contentSize = _ref.contentSize,
      fileFormat = _ref.fileFormat,
      height = _ref.height,
      lastModified = _ref.lastModified,
      name = _ref.name,
      width = _ref.width;

  return _react2.default.createElement(
    'div',
    { className: 'dz-details' },
    _react2.default.createElement(
      'div',
      { className: 'dz-filename' },
      _react2.default.createElement(_Label2.default, { text: 'Name:' }),
      name
    ),
    _react2.default.createElement(
      'div',
      { className: 'dz-fileformat' },
      _react2.default.createElement(_Label2.default, { text: 'Format:' }),
      fileFormat
    ),
    _react2.default.createElement(
      'div',
      { className: 'dz-filemodified' },
      _react2.default.createElement(_Label2.default, { text: 'Modified:' }),
      lastModified
    ),
    contentSize && _react2.default.createElement(_FileSize2.default, { contentSize: contentSize }),
    contentSha1 && _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_Label2.default, { text: 'SHA-1' }),
      contentSha1
    ),
    height && width && _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'span',
        null,
        width.value
      ),
      _react2.default.createElement(
        'span',
        null,
        'x'
      ),
      _react2.default.createElement(
        'span',
        null,
        height.value
      )
    )
  );
}
FileDetails.propTypes = {
  contentSha1: _propTypes2.default.string,
  contentSize: _propTypes2.default.number.isRequired,
  fileFormat: _propTypes2.default.string,
  height: _propTypes2.default.shape({ value: _propTypes2.default.number }),
  lastModified: _propTypes2.default.number,
  name: _propTypes2.default.string.isRequired,
  width: _propTypes2.default.shape({ value: _propTypes2.default.number })
};
FileDetails.defaultProps = {};
exports.default = FileDetails;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/cape-mixer/lib/FileUpload/FileDetails.js
// module id = 683
// module chunks = 0